import React from "react";
import { Container } from "./styles";
import { ErrorCard } from "ui";
import useLocation from "hooks/useLocation";

class ErrorBoundery extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errorOccurred: false };
  }

  static getDerivedStateFromError(error) {
    return { errorOccurred: true };
  }

  componentDidCatch(error, info) {}

  render() {
    if (this.state.errorOccurred) {
      return (
        <Container
        $isCreators={this.props.isCreators}
        >
          <ErrorCard
            title='Algo salió mal'
            description='Hubo un error inesperado. Recarga la página y reintentalo.'
            code='W1001'
            isBackHome
          />
        </Container>
      );

    } else {
      return this.props.children;
    }
  }
}


const ErrorBounderyWrapper = ({ children }) => {
  const { isCreators } = useLocation()

  return (
    <ErrorBoundery isCreators={isCreators}>
      {children}
    </ErrorBoundery>
  )
}

export default ErrorBounderyWrapper;
